// ScaleContext.js
import React from 'react';

const ScaleContext = React.createContext(1); // Default scale is 1

export default ScaleContext;
